import { css } from "@emotion/core";
import { color } from "../../constants/commons";
import { ModalSizeType } from "../../atoms/Modal/interface";

export const modalStyles = (width: ModalSizeType, isMobile: boolean) => css`
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0 0 0 / 0.3);
  display: flex;
  ${!isMobile && `align-items: center;`}
  justify-content: center;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);

  ${isMobile &&
  `
    overflow: scroll;
    padding-top: 5em;
  `}

  // .custom-modal {
  //   position: -webkit-sticky;
  //   position: sticky;
  //   top: 10vh;
  //   bottom: 25vh;
  // }

  ${width === ModalSizeType.LARGE &&
  `.custom-modal{
    width: 90%;
  }`}
  ${width === ModalSizeType.MEDIUM &&
  `.custom-modal{
    width: 40%;
    min-width: 28.1em;
  }`}
  ${width === ModalSizeType.SMALL &&
  `.custom-modal{
    width: 25%;
    min-width: 18.75em;
  }`}
  .custom-modal-content {
    background: ${color.white};
    padding: 2em;
    display: flex;
    border-radius: 1.25em;
    .custom-modal-data {
      flex: 1;
      text-align: center;
      padding-left: 20px;
    }
    .close {
      background: ${color.backgroundGray};
      padding: 0.44em;
      border-radius: 50%;
      cursor: pointer;
    }
  }
  .custom-modal-extra-content > :first-of-type {
    display: flex;
    justify-content: space-evenly;
  }
  .custom-modal-extra-content {
    margin-top: 0.63em;
  }
`;
